/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Per_MoInputs */

const en_premium_per_mo = /** @type {(inputs: Premium_Per_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const es_premium_per_mo = /** @type {(inputs: Premium_Per_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Premium_Per_MoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_per_mo = /** @type {((inputs?: Premium_Per_MoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Per_MoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_per_mo(inputs)
	return en_premium_per_mo(inputs)
});